import { Grid, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ClearRounded } from "@mui/icons-material";
import { DropLi } from "../../hooks";
import { useTranslation } from "react-i18next";

const ViewUser = (props) => {
  const { t } = useTranslation();
  const { setShowForm, viewData } = props;
  const [user, setUser] = useState({});
  const { Gender } = DropLi();
  const handleClose = () => {
    setShowForm(false);
  };
  useEffect(() => {
    if (viewData) {
      var genderName = Gender.find((j) => j.id === viewData.gender);
      setUser({
        ...viewData,
        gender: genderName ? genderName.label : "",
        cityName: viewData.city && viewData.city.name,
      });
    }
    return () => {
      setUser({});
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewData]);
  return (
    <>
      {user ? (
        <Grid container spacing={3} className="p-15 dark-color mb-10">
          <Grid item xs={12}>
            <div className="mb-15 d-flex j-between a-center">
              <div>
                <span
                  className="fs-20 mb-5 fw-5 gray-color tx-upp
                    border-left"
                >
                  {t("UserDetails")}
                </span>
              </div>

              <div>
                <IconButton onClick={handleClose} size="small" className="mr-5">
                  <ClearRounded className="fs-20 m-2" />
                </IconButton>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color grayMD-color">
              {t("UserId")}
            </span>
            <span className="fs-16 fw-4 gray-color">{user.id}</span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">{t("Name")}:</span>
            <span className="fs-16 fw-4 gray-color gray-color">
              {user.firstName + " " + user.lastName}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("Gender")}:
            </span>
            <span className="fs-16 fw-4 gray-color gray-color">
              {user.gender}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("DateOfBirth")}:
            </span>
            <span className="fs-16 fw-4 gray-color gray-color">{user.dob}</span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("Mobile")}
            </span>
            <a
              className="link fs-16 fw-4 gray-color"
              href={`tel:${user.phone}`}
            >
              {user.phone}
            </a>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">{t("Email")}</span>
            <a
              className="link fs-16 fw-4 gray-color"
              href={`mailto:${user.email}`}
            >
              {user.email}
            </a>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">{t("City")}</span>
            <span className="fs-16 fw-4 gray-color">{user.cityName}</span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">{t("State")}</span>
            <span className="fs-16 fw-4 gray-color">{user.state}</span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("Address")}:
            </span>
            <span className="fs-16 fw-4 gray-color">{user.address}</span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">{t("Note")}:</span>
            <span className="fs-16 fw-4 gray-color">{user.note}</span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("AddedDate")}
            </span>
            <span className="fs-16 fw-4 gray-color">05/12/2022</span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("LastUpdateDate")}
            </span>
            <span className="fs-16 fw-4 gray-color">05/12/2022</span>
          </Grid>
        </Grid>
      ) : (
        <span> {t("Loading")}...</span>
      )}
    </>
  );
};

export default ViewUser;
